import { Btn } from "../../utils/ui.jsx";

export function AddLookupModal({ open, title, placeholder, value, onChange, onCancel, onAdd }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/45 z-[9999] flex items-center justify-center p-5">
      <div className="bg-white rounded-[14px] max-w-[380px] w-full p-6 shadow-[0_8px_40px_rgba(0,0,0,0.2)]">
        <div className="font-bold text-[15px] text-zephyr-teal-dark mb-[14px]">{title}</div>
        <input
          value={value}
          onChange={function (e) {
            onChange(e.target.value);
          }}
          placeholder={placeholder}
          className="py-2 px-3 rounded-[8px] border border-zephyr-border text-[13px] text-zephyr-text bg-white w-full box-border mb-[14px]"
          style={{ fontFamily: "inherit" }}
        />
        <div className="flex gap-[10px] justify-end">
          <Btn variant="secondary" onClick={onCancel}>
            Cancel
          </Btn>
          <Btn onClick={onAdd}>Add</Btn>
        </div>
      </div>
    </div>
  );
}
